// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Component } from '../../utils';
import PropTypes from 'prop-types';

class ScrollDirection extends Component {
    state = {
        direction: 'up',
    };

    prevScrollTop = 0;

    handleScroll = e => {
        const { scrollTop } = e.target;
        const direction = scrollTop > this.prevScrollTop ? 'down' : 'up';

        this.prevScrollTop = scrollTop;
        this.setState({
            direction,
        });
    };

    render() {
        const { children } = this.props;

        return children({
            direction: this.state.direction,
            handleScroll: this.handleScroll,
        });
    }
}
ScrollDirection.propTypes = {
    children: PropTypes.func.isRequired,
};

export default ScrollDirection;



// WEBPACK FOOTER //
// ./components/Drawer/ScrollDirection.js